<script lang="ts">
	import { format } from 'svelte-i18n';
	import { scenes } from 'src/stores/lists/scenes';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { ActionsContainer, DeviceButton, Label } from '@Shelly/shelly-design-system';
	import ControlSceneEnable from '../../Controls/Scene/ControlSceneEnable.svelte';
	import ControlScenePlay from '../../Controls/Scene/ControlScenePlay.svelte';

	export let item;
	export let variant: 'listMenuCard' | 'widgetCard' | 'drawer' | 'dashControlWidget';
	export let withoutPlayBtn = false;
	export let showEnableBtn = true;

	let isBroken = $scenes[item?.id]?._meta?.broken;
</script>

{#if variant === 'dashControlWidget'}
	{#if variant === 'dashControlWidget'}
		<div class="d-flex gap-s">
			<ControlScenePlay {item} {variant} />

			{#if showEnableBtn}
				<ControlSceneEnable {item} {variant} />
			{/if}
		</div>
	{:else}
		<Label
			id="devicebutton-l7qeqz5"
			aria-label={$format('label_device_button', { default: 'Device button' })}
			type="color-0"
			style="width:40px; height:40px; min-height:unset"
			icon="fal fa-circle-xmark text-color-danger"
			size="l"
			isVertical
		/>
	{/if}
{:else if !isBroken}
	{#if $showNewLayout && variant === 'listMenuCard'}
		{#if !withoutPlayBtn}
			<ActionsContainer
				orientation="vertical"
				slot="right"
				bgColor="color-base"
				type="separator"
				separatorColor="color-2"
			>
				<ControlSceneEnable {item} {variant} slot="first" />

				<ControlScenePlay {item} {variant} slot="second" />
			</ActionsContainer>
		{:else}
			<ActionsContainer
				orientation="vertical"
				slot="right"
				bgColor="color-base"
				type="separator"
				separatorColor="color-2"
			>
				<ControlSceneEnable {item} {variant} slot="first" />
			</ActionsContainer>
		{/if}
	{:else if !withoutPlayBtn}
		<ActionsContainer
			type={variant === 'widgetCard' ? 'simple' : 'separator'}
			orientation={variant === 'widgetCard' ? 'horizontal' : 'vertical'}
		>
			<ControlSceneEnable {item} {variant} slot="first" />

			<ControlScenePlay {item} {variant} slot="second" />
		</ActionsContainer>
	{:else}
		<ActionsContainer
			type={variant === 'widgetCard' ? 'simple' : 'separator'}
			orientation={variant === 'widgetCard' ? 'horizontal' : 'vertical'}
		>
			<ControlSceneEnable {item} {variant} slot="first" />
		</ActionsContainer>
	{/if}
{:else}
	<ActionsContainer orientation="vertical" type="simple">
		<DeviceButton
			id="devicebutton-l7qeqz5"
			aria-label={$format('label_device_button', { default: 'Device button' })}
			icon="fas fa-circle-exclamation"
			variant="danger"
			slot="first"
			disabled
			on:click={() => {
				console.warn(`Error ${$format('broken_scene_err_toast')}`);
			}}
		/>
	</ActionsContainer>
{/if}
